import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vjqfbthsp3: FaireBrandEntity = {
  token: "b_vjqfbthsp3",
  type: "brand",
  name: "Brookhaven Baubles",
  avatarUrl: "https://cdn.faire.com/fastly/db0449ab75e35d132388634c075ee1eff74cfbab18b1a5ee2b3106510df77d98.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/c8556708a17ddfdfcfdf358dd59adf26afc96078387e1eba55595df826758c18.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/db0449ab75e35d132388634c075ee1eff74cfbab18b1a5ee2b3106510df77d98.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/c8556708a17ddfdfcfdf358dd59adf26afc96078387e1eba55595df826758c18.jpeg",
  location: "Brookhaven, GA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 37,
  isTopShop: true,
  isInsider: true,
  description: "\nSouthern Statement Jewelry\nWelcome to Brookhaven Baubles!\n\nWe are two neighbors who spent many nights together in quarantine and after a bottle of champagne, Brookhaven Baubles was born! We are excited to bring our southern class, charm and style to your every day outfits. Our baubles are mostly made of light weight acrylic seed beads or raffia and are so light that you will practically forget you are wearing them.\n\nWe’ve also started to launch what we call our Brookhaven Baubles Classics - more of your everyday chic hoops, pearls, or studs. Stay tuned for more as we continue to expand this part of our shop.\n\nOur earrings will dress up even a basic white t-shirt and leggings, so don’t go spend money on a new outfit, just add some fun accessories! Our earrings are the perfect statement for any occasion. They are great for everyday, a night out, weddings, wedding guests, bridal showers, bachelorettes, mom, co-workers, birthday gifts, hostess gifts, vacations, and more! Grab a pair for your bestie and a few gifts while you are at it.\n\nThank you for your support!",
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:31:05.050Z",
    importedBy: "entity-db-cli"
  }
};
